import isObject from 'lodash/isObject'
import merge from 'lodash/merge'
import omit from 'lodash/omit'

export function urlToUri (url) {
  if (typeof window === 'undefined') return url
  if (typeof url !== 'string') return url
  if (!/https?:\/\//.test(url)) return url

  return url.replace(window.location.origin, '')
}

export function updateQueryParams (router, params = {}) {
  return new Promise(function (resolve, reject) {
    if (!isObject(params)) {
      return reject(new Error(`Argument 'params' must be an object.`))
    }

    const restOfQueryParams = omit(router.currentRoute.query, Object.keys(params))
    const query = merge({}, restOfQueryParams, params)
    const route = omit(router.currentRoute, 'query')
    route.query = query

    const done = function () {
      return resolve(route)
    }

    router.push(route, done, done)
  })
}
